import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ILoginState } from '../store/login/login';
import { getCookie, pathGenerate } from '@poste-click-connect/shared-ui';
import { LoginPayload } from '../interfaces/login-payload';
import { Config } from '../interfaces/config';
import { ResponseRetrievePassword } from '../interfaces/response-retrieve-password';
import { RetrievePasswordPayload } from '../interfaces/retrieve-password-payload';
import { ResponseReteterzaReport } from '../interfaces/response-reteterza-report';
import { RetrieveReteterzaReportPayload } from '../interfaces/retrieve-reteterza-report-payload';
import {
  IPayloadPuntoPoste,
  IPayloadPuntoPosteDetail,
} from '../interfaces/retrive-report-punto-poste-payload';
import { IResponseReportPuntoPoste } from '../interfaces/response-report-punto-poste';
import { IResponsePuntoPosteDetail } from '../interfaces/retrive-dettaglio-punto-poste';
import {
  IPayloadOperationMonitoring,
  IResponseMonitoringDetail,
  IResponseOperationMonitoring,
  Operazioni,
} from '../interfaces/monitoring';
import {
  PayloadAnagrafica,
  ResponseAggiuntaAnagrafica,
  ResponseAnagraphicManagement,
} from '../interfaces/response-anagraphic-management';
import { ResponseReteTerzaDettaglio } from '../interfaces/response-rete-terza-dettaglio';
import {
  RetrieveInterfaceMonitoringCrm,
  RetrieveInterfaceMonitoringSap,
  RetrieveInterfaceMonitoringDashboard,
} from '../interfaces/retrieve-interface-monitoring';
import { ResponseInterfaceMonitoringSap } from '../interfaces/response-interface-monitoring-sap';
import { ResponseInterfaceMonitoringCrm } from '../interfaces/response-interface-monitoring-crm';
import { ResponseInterfaceMonitoringDashboard } from '../interfaces/response-interface-monitoring-dashboard';
import {
  IPayloadCambioPassword,
  IResponseCambioPassword,
} from '../interfaces/change-password';
import { PayloadRetrieveDocuments } from '../interfaces/retrieve-documents';
import { ResponseDocuments } from '../interfaces/response-documents';

import {
  PayloadCrm,
  PayloadSap,
  ResponseCRMO,
  ResponseSAP,
  ResponseDashboard,
  PayloadDashboard,
} from '../interfaces/response-monitoring-interface';
import {
  PayloadStoricoOperazioni,
  ResponseStoricoOperazioni,
} from '../interfaces/response-operation-history';
import {
  IComuni,
  IProvince,
  IRegioni,
  payloadComuni,
  payloadProvince,
} from '../interfaces/location';
import {
  ResponseInterfaceHistoryCrm,
  RetrieveInterfaceHistoryCrm,
} from '../interfaces/response-interface-history-crm';
import { IPayloadtemplatePuntoPoste } from '../interfaces/anagraphic-new-operation';
import { ResponseOperazioniProgressivo } from '../interfaces/response-operation-progressive';
import {
  IPayloadCd,
  IPayloadRam,
  IResponseCd,
  IResponseMal,
  IResponseRam,
} from '../interfaces/mal-ram-cd';
import {
  IPayloadCambioStato,
  IResponseCambioStato,
  IResponseCambioStatoPps,
  IResponseListaGestionePunti,
  ISingleObjectGestionePunti,
} from '../interfaces/points-management';
import {
  IPayloadConfermaCaricamentoAttivazioneMassiva,
  IResponseConfermaCaricamentoAttivazioneMassiva,
  IResponseUploadAttivazioneMassiva,
} from '../interfaces/attivazione-massiva';
import { DownloadDetailReportPostPoint } from '../interfaces/download-detail-report-post-point';
import {
  IPayloadCreazioneUtenza,
  IResponseCreazioneUtenza,
  IResponseGestioneUtenze,
} from '../interfaces/gestione-utenze';
import { RetrieveUtilityLdv } from '../interfaces/retrieve-utility-ldv';
import { GenericResponse } from '../interfaces/generic-response';
import { IPayloadDownloadUtilityReportPuntoPoste } from '../interfaces/utility-report-punto-poste';
import {
  IResponseCompensiRete,
  IResponseCompensiRetePost,
} from '../interfaces/compensi';
import { IConfigurazioneBoxless } from '../interfaces/configurazione-boxless';
import { RetrieveGestionPuntoPoste } from '../interfaces/retrieve-gestione-puntoposte';
import {
  PayloadCP,
  ResponseCMP,
  ResponseCP,
} from '../interfaces/puntoposte-detail';
import {
  IPayloadReportGiacenzeXls,
  IResponseReportGiacenzeList,
} from '../interfaces/report-giacenze';
import {
  PayloadNearlistXls,
  ResponseNearlistUffPostale,
} from '../interfaces/nearlist';
import { IPayloadMig2Download } from '../interfaces/mig2';
import { ResponseCercaPerStrutturaRecapito } from '../interfaces/cerca-per-struttura-recapito';
import {
  IPayloadGo,
  IResponseGo,
  IPayloadRamGo,
  IResponseRamGo,
  IPayloadCdGo,
  IResponseCdGo,
  IPayloadFraz,
  IResponseFraz,
  IResponseRecapito,
} from '../interfaces/go';
import { PayloadCercaStrutturaRecapito } from '../interfaces/payload-cerca-struttura-recapito';
import {
  IDeleteElNoticeboard,
  IPayloadBoardList,
  ResponseComunicationBoardList,
} from '../interfaces/response-comunication-board-list';
import { ResponseRetrieveRecipients } from '../interfaces/retrieve-recipients';
import { ResponseReportBoardList } from '../interfaces/report-comunicazioni-bacheca';
import { IResponseRichiediExport } from '../interfaces/richiedi-export';
import {
  IPayloadStoricoSap,
  IResponseStoricoSap,
} from '../interfaces/response-interface-history-sap';
import { IUploadFileResult } from '../store/massive-upload/massive-upload';
import {
  IResponseListaCatalogoMateriale,
  ISaveListaCatalogoMateriale,
} from '../interfaces/catalogo-materiale';
import { IResponseCluster } from '../interfaces/cluster';
import {
  IPayloadConfigurazioneApprovvigionamento,
  IResponseConfigurazioneApprovvigionamento,
  IResponseOrdiniApprovvigionamento,
} from '../interfaces/configurazione-approvvigionamento';
import { IResponseRegoleOrdine } from '../interfaces/regole-ordine';
import { ResponseOrderHistory } from '../interfaces/response-order-history';
import { PayloadOrderHistory } from '../interfaces/payload-order-history';
import { CatalogoAppartenenza } from '../interfaces/catalogo-appartenenza';
import { ClasseAppartenenza } from '../interfaces/classe-appartenenza';
import { ResponseCreazioneOrdine } from '../interfaces/response-creazione-ordine';
import {
  IPayloadVerifyRecipientsList,
  IResponseVerifyRecipientsList,
} from '../interfaces/response-verify-recipients-list';
import {
  IPayloadSaveRecipientsList,
  SaveRecipientsList,
} from '../interfaces/response-save-recipients-list';
import { IResponseRetrieveHeaderDetail } from '../interfaces/response-retrieve-header-detail';
import { PayloadHeaderDetail } from '../interfaces/payload-header-detail';
import { ResponseMessageBoardList } from '../interfaces/messaggi-comunicazioni-bacheca';
import { ResponseRecipientsBoardList } from '../interfaces/destinatari-comunicazioni-bacheca';
import {
  IPayloadSaveDetailMessageBoardList,
  ResponseSaveDetailComunicationBoardList,
} from '../interfaces/response-save-detail-comunication-board-list';
import {
  IPayloadInvioDetailMessageBoardList,
  ResponseInvioDetailComunicationBoardList,
} from '../interfaces/response-invio-detail-comunication-board-list';
import {
  IPayloadSaveDetailMessageBoardListPut,
  ResponseSaveDetailComunicationBoardListPut,
} from '../interfaces/response-save-detail-comunication-board-list-put';
import { ResponseIdRecipients } from '../interfaces/retrieve-id-recipientslist';
import { PayloadEditStateHeader } from '../interfaces/payload-edit-state-header';
import { RetrieveRetilockerReportPayload } from '../interfaces/retrieve-retiLocker-report-payload';
import { ResponseRetiLockerReport } from '../interfaces/response-reti-locker-report';
import {
  IPayloadPuntoPosteLocker,
  IPayloadPuntoPosteLockerDetail,
} from '../interfaces/retrieve-report-punto-poste-locker-payload';
import { IResponsePuntoPosteLockerDetail } from '../interfaces/retrieve-punto-poste-locker-detail';
import { DownloadDetailReportPostPointLocker } from '../interfaces/download-detail-report-post-point-locker';
import { IResponseReportPuntoPosteLocker } from '../interfaces/response-report-punto-poste-locker';
import {
  IPayloadReportGiacenzeLockerXls,
  IResponseReportGiacenzeLockerList,
} from '../interfaces/report-giacenze-locker';
import {
  IPayloadStoricoDashboard,
  IResponseStoricoDashboard,
} from '../interfaces/response-interface-history-dashboard';
import {
  IPinRecoveryPayload,
  IResponsePinRecovery,
} from '../interfaces/pin-recovery';
import {
  IPayloadStoricoIcon,
  IResponseStoricoIcon,
} from '../interfaces/monitoraggio-storico-icon';
import {
  IPayloadConfermaCaricamentoPreAttivazione,
  IResponseConfermaCaricamentoPreAttivazione,
  IResponseUploadPreAttivazione,
} from '../interfaces/forzatura-preattivazione';
import { IResponseListaAttivazioniPP } from '../interfaces/listaAttivazioniPP';
import {
  IPayloadConfermaCaricamentoMassivoFileFerie,
  IResponseConfermaCaricamentoFileFerieMassivo,
  IResponseUploadFileFerieMassivo,
} from '../interfaces/upload-ferie-response';
import {
  IPayloadConfermaCaricamentoMassivoFileGestioneUtenze,
  IResponseConfermaCaricamentoFileGestioneUtenzeMassivo,
  IResponseUploadFileGestioneUtenzeMassivo,
} from '../interfaces/upload-gestione-utenze-response';
import { IResponseStoricoOrdiniPartner, IResponseStoricoOrdiniProfili } from '../interfaces/storico-ordini-filter-options';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private basepath: string = '';
  private staticBasepath: string = '';
  private isLocal: boolean = true;
  private apiRoot = '/ClickECollectBO-BE'; // default di fallback

  constructor(private http: HttpClient) {}

  retrieveConfig(): Observable<Config> {
    return this.http.get<Config>('assets/config/config.json').pipe(
      tap((cfg) => {
        this.basepath = cfg.basepath;
        this.staticBasepath = cfg.staticBasepath;
        this.isLocal = this.toBool(cfg.isLocal, true); // scegli fallback
        this.apiRoot = cfg.apiRoot || this.apiRoot;
      })
    );
  }

  private toBool(v: unknown, fallback = false): boolean {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'string') return v.trim().toLowerCase() === 'true';
    return fallback;
  }

  login(body: LoginPayload): Observable<ILoginState> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/listaAccessi/login'
    );

    return this.http.put<ILoginState>(path, body);
  }

  retrievePassword(
    body: RetrievePasswordPayload
  ): Observable<ResponseRetrievePassword> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/listaAccessi/recuperapassword'
    );

    return this.http.put<ResponseRetrievePassword>(path, body);
  }

  retrieveRendicontazione(): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/rendicontazione/list'
    );

    return this.http.get<any>(path);
  }

  downloadRendicontazione(fileName: string): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/rendicontazione/${fileName}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.get<any>(path, options);
  }

  retrieveReteterzaReport(
    payload: RetrieveReteterzaReportPayload
  ): Observable<ResponseReteterzaReport> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza/report'
    );

    return this.http.post<ResponseReteterzaReport>(path, payload);
  }

  //TODO: Fix endpoint per report punto poste locker
  retrieveRetiLockerReport(
    payload: RetrieveRetilockerReportPayload
  ): Observable<ResponseRetiLockerReport> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/report'
    );

    return this.http.post<ResponseRetiLockerReport>(path, payload);
  }

  visualizzaReportPuntoPoste(
    payload: IPayloadPuntoPoste
  ): Observable<IResponseReportPuntoPoste> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/report'
    );

    return this.http.post<IResponseReportPuntoPoste>(path, payload);
  }

  //TODO: Fix endpoint per report punto poste locker + fix inteface req e res
  visualizzaReportPuntoPosteLocker(
    payload: IPayloadPuntoPosteLocker
  ): Observable<IResponseReportPuntoPosteLocker> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/report/pp'
    );

    return this.http.post<IResponseReportPuntoPosteLocker>(path, payload);
  }

  dettaglioReportPuntoPoste(
    payload: IPayloadPuntoPosteDetail
  ): Observable<IResponsePuntoPosteDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/dettaglioReport'
    );

    return this.http.post<IResponsePuntoPosteDetail>(path, payload);
  }

  dettaglioReportPuntoPosteLocker(
    payload: IPayloadPuntoPosteLockerDetail
  ): Observable<IResponsePuntoPosteLockerDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/dettaglioReport'
    );

    return this.http.post<IResponsePuntoPosteLockerDetail>(path, payload);
  }

  downloadReportPuntoPoste(
    payload: Partial<IResponsePuntoPosteDetail>
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/dettaglioReport/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<any>(path, payload, options);
  }

  downloadLdvDoc(payload: string): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/spedizione/downloadZip/${payload}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.get<any>(path, options);
  }

  downloadReportPuntoPosteLista(
    payload: Partial<IResponsePuntoPosteDetail>
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/report/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<any>(path, payload, options);
  }

  downloadReportPuntoPosteListaLocker(
    payload: IPayloadPuntoPosteLocker
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/report/pp/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<any>(path, payload, options);
  }

  downloadDettaglioReportPuntoPoste(
    payload: DownloadDetailReportPostPoint
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza/reportDettaglio'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.post<any>(path, payload, options);
  }

  downloadRetiTerze(
    payload: Partial<IResponsePuntoPosteDetail>
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza/report/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<any>(path, payload, options);
  }

  downloadRetiLocker(
    payload: RetrieveRetilockerReportPayload
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/report/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<any>(path, payload, options);
  }

  downloadDettaglioReportPuntoPosteLocker(
    payload: DownloadDetailReportPostPointLocker
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/reportDettaglio'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.post<any>(path, payload, options);
  }

  downloadReportPuntoPosteLocker(
    payload: Partial<IResponsePuntoPosteLockerDetail>
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/retiLocker/dettaglioReport/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<any>(path, payload, options);
  }

  retrieveAnagrafica(): Observable<ResponseAnagraphicManagement> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza/list'
    );

    return this.http.get<ResponseAnagraphicManagement>(path);
  }

  retrieveAggiuntaAnagrafica(
    payload: PayloadAnagrafica
  ): Observable<ResponseAggiuntaAnagrafica> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza'
    );

    return this.http.put<ResponseAggiuntaAnagrafica>(path, {
      reteTerza: payload,
    });
  }

  retrieveReteTerzaDettaglio(
    sigla: string
  ): Observable<ResponseReteTerzaDettaglio> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/reteterza/${sigla}`
    );

    return this.http.get<ResponseReteTerzaDettaglio>(path);
  }

  editReteTerzaDettaglio(
    payload: PayloadAnagrafica
  ): Observable<ResponseAggiuntaAnagrafica> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza'
    );

    return this.http.post<ResponseAggiuntaAnagrafica>(path, {
      reteTerza: payload,
    });
  }

  monitoringOperation(
    payload: IPayloadOperationMonitoring,
    sigla: string
  ): Observable<IResponseOperationMonitoring> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/monitoraggio/${sigla}`
    );

    return this.http.post<IResponseOperationMonitoring>(path, payload);
  }

  interfaceMonitoringCrm(
    payload: RetrieveInterfaceMonitoringCrm
  ): Observable<ResponseInterfaceMonitoringCrm> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/monitoraggioCRM/${payload.rete}`
    );

    return this.http.post<ResponseInterfaceMonitoringCrm>(path, payload);
  }

  monitoringApproved(payload: {
    operazioni: Operazioni[];
  }): Observable<{ esito: string; errorDescr?: string }> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/monitoraggio/approvazione`
    );

    return this.http.post<{ esito: string; errorDescr?: string }>(
      path,
      payload
    );
  }

  interfaceMonitoringSap(
    payload: RetrieveInterfaceMonitoringSap
  ): Observable<ResponseInterfaceMonitoringSap> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/monitoraggioSAP/${payload.rete}`
    );

    return this.http.post<ResponseInterfaceMonitoringSap>(path, payload);
  }

  interfaceMonitoringDashboard(
    payload: RetrieveInterfaceMonitoringDashboard
  ): Observable<ResponseInterfaceMonitoringDashboard> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/monitoraggioDashboard/${payload.siglaRt}`
    );

    return this.http.post<ResponseInterfaceMonitoringDashboard>(path, payload);
  }

  retrieveDocuments(
    payload: PayloadRetrieveDocuments
  ): Observable<ResponseDocuments> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/documenti/${payload.tipoDocumento}`
    );

    return this.http.post<ResponseDocuments>(path, payload);
  }

  retriveMonitoringDetail(
    idOperazione: number
  ): Observable<IResponseMonitoringDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/dettaglioContratto/${idOperazione}`
    );
    return this.http.get<IResponseMonitoringDetail>(path);
  }
  retrieveCambioPassword(
    payload: IPayloadCambioPassword
  ): Observable<IResponseCambioPassword> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/listaAccessi/cambiopassword'
    );

    return this.http.put<IResponseCambioPassword>(path, payload);
  }

  downloadMonitoringReport(
    operazioni: any,
    rete: string,
    tab: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/generaExcel/${rete}/${tab}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, operazioni, options);
  }

  downloadMonitoringReportSap(
    operazioni: any,
    rete: string,
    tab: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/generaExcelSap/${rete}/${tab}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, operazioni, options);
  }

  downloadMonitoringReportDashboard(
    operazioni: any,
    rete: string,
    tab: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/generaExcelDashboard/${rete}/${tab}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, operazioni, options);
  }

  retrieveDetailCrmo(idOperazione: string): Observable<ResponseCRMO> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/dettaglioContrattoCRM/${idOperazione}`
    );

    return this.http.get<ResponseCRMO>(path);
  }

  retrieveRisottomettiCrm(payload: PayloadCrm): Observable<ResponseCRMO> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/risottomettiCRM`
    );

    return this.http.post<ResponseCRMO>(path, payload);
  }

  retrieveStoricoOperazioni(
    payload: PayloadStoricoOperazioni
  ): Observable<ResponseStoricoOperazioni> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/storico/${payload.rete}`
    );

    return this.http.post<ResponseStoricoOperazioni>(path, payload);
  }

  uploadFile(
    formData: FormData,
    sigla: string
  ): Observable<{ esito: string; errorDescr?: string }> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/documenti/upload/` + sigla
    );
    return this.http.post<{ esito: string; errorDescr?: string }>(
      path,
      formData
    );
  }

  retrieveDetailSap(idOperazione: string): Observable<ResponseSAP> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/dettaglioOperazioneSAP/${idOperazione}`
    );

    return this.http.get<ResponseSAP>(path);
  }

  retrieveDetailDashboard(idOperazione: string): Observable<ResponseDashboard> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/dettaglioOperazioneDashboard/${idOperazione}`
    );

    return this.http.get<ResponseDashboard>(path);
  }

  retrieveRisottomettiSap(payload: PayloadSap): Observable<ResponseSAP> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/risottomettiSAP`
    );

    return this.http.post<ResponseSAP>(path, payload);
  }

  retrieveRisottomettiDashboard(
    payload: PayloadDashboard
  ): Observable<ResponseDashboard> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/risottomettiDashboard`
    );

    return this.http.post<ResponseDashboard>(path, payload);
  }

  downloadTemplateNuovaoperazionePrecompilato(
    payload: IPayloadtemplatePuntoPoste,
    idOperazione: string,
    reteTerza: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/template/${idOperazione}/${reteTerza}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, payload, options);
  }

  downloadMassiveUploadPrecompiled(payload: any): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/ordine/template`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.post<any>(path, payload, options);
  }

  retrieveOperazioniProgressivo(): Observable<ResponseOperazioniProgressivo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/progressivo`
    );

    return this.http.get<ResponseOperazioniProgressivo>(path);
  }

  retrieveCatalogoAppartenenza(): Observable<CatalogoAppartenenza> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/catalogoAppartenenza`
    );
    return this.http.get<CatalogoAppartenenza>(path);
  }

  retrieveClasseAppartenenza(payload: {
    clusterAppartenenza: string;
  }): Observable<ClasseAppartenenza> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/classeAppartenenza`
    );
    return this.http.post<ClasseAppartenenza>(path, payload);
  }

  retriveRegioni(): Observable<IRegioni> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/localizzazione/regioni/list`
    );
    return this.http.get<IRegioni>(path);
  }

  interfaceHistoryCrm(
    payload: RetrieveInterfaceHistoryCrm
  ): Observable<ResponseInterfaceHistoryCrm> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/storicoCRM/${payload.rete}`
    );

    return this.http.post<ResponseInterfaceHistoryCrm>(path, payload);
  }

  interfaceHistorySap(
    payload: IPayloadStoricoSap
  ): Observable<IResponseStoricoSap> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/storicoSAP/${payload.rete}`
    );

    return this.http.post<IResponseStoricoSap>(path, payload);
  }

  interfaceHistoryDashboard(
    payload: IPayloadStoricoDashboard
  ): Observable<IResponseStoricoDashboard> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/storicoDashboard/${payload.siglaRt}`
    );

    return this.http.post<IResponseStoricoDashboard>(path, payload);
  }

  retriveProvince(payload: payloadProvince): Observable<IProvince> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/localizzazione/province/list`
    );
    return this.http.post<IProvince>(path, payload);
  }

  retriveComuni(payload: payloadComuni): Observable<IComuni> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/localizzazione/comuni/list`
    );
    return this.http.post<IComuni>(path, payload);
  }

  uploadNewOperationfile(
    payload: FormData,
    idOperazione: string,
    reteTerza: string,
    isPut: boolean
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/${idOperazione}/${reteTerza}`
    );

    if (isPut) {
      return this.http.put<any>(path, payload);
    } else {
      return this.http.post<any>(path, payload);
    }
  }

  uploadDocumentLdv(
    payload: FormData,
    idSpedizione: string,
    state: string
  ): Observable<GenericResponse> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/spedizione/${idSpedizione}/${state}`
    );

    return this.http.post<GenericResponse>(path, payload);
  }

  retriveMal(): Observable<IResponseMal> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/mal/list`
    );
    return this.http.get<IResponseMal>(path);
  }

  retriveRam(payload?: IPayloadRam): Observable<IResponseRam> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/ram/list`
    );
    return this.http.post<IResponseRam>(path, payload);
  }

  retriveCd(payload?: IPayloadCd): Observable<IResponseCd> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/cd/list`
    );
    return this.http.post<IResponseCd>(path, payload);
  }

  retrieveGo(payload?: IPayloadGo): Observable<IResponseGo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/go/list`
    );
    return this.http.post<IResponseGo>(path, payload);
  }

  retrieveRamGo(payload?: IPayloadRamGo): Observable<IResponseRamGo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/ram/list`
    );
    return this.http.post<IResponseRamGo>(path, payload);
  }

  retrieveCdGo(payload?: IPayloadCdGo): Observable<IResponseCdGo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/cd/list`
    );
    return this.http.post<IResponseCdGo>(path, payload);
  }

  retrieveFraz(payload?: IPayloadFraz): Observable<IResponseFraz> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/gerarchia/frazionario/list`
    );
    return this.http.post<IResponseFraz>(path, payload);
  }

  retriveListaGestionePunti(
    payload?: any
  ): Observable<IResponseListaGestionePunti> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/list`
    );
    return this.http.post<IResponseListaGestionePunti>(path, payload);
  }

  downloadReportGestionePunti(
    payload: ISingleObjectGestionePunti[],
    isApt: boolean
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      isApt
        ? this.apiRoot + '/cp/anagraficaApt/xls'
        : this.apiRoot + '/cp/anagrafica/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.put<any>(path, payload, options);
  }

  retriveCambioStatoPuntoPoste(
    payload: IPayloadCambioStato
  ): Observable<IResponseCambioStato> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/stato`
    );
    return this.http.post<IResponseCambioStato>(path, payload);
  }

  retriveCambioStatoPuntoPostePps(
    payload: IPayloadCambioStato
  ): Observable<IResponseCambioStatoPps> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/stato/pps`
    );
    return this.http.post<IResponseCambioStatoPps>(path, payload);
  }

  downloadAttivazioneMassivaPrecompilato(
    payload: { action4: string },
    reteTerza: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/template/list/activate/${reteTerza}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, payload, options);
  }

  downloadPreAttivazioneMassivaPrecompilato(
    payload: { action4: string },
    reteTerza: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/template/list/activate/${reteTerza}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, payload, options);
  }

  uploadAttivazioneMassivafile(
    payload: FormData
  ): Observable<IResponseUploadAttivazioneMassiva> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/list/activate?Authorization=${getCookie(
        'accessToken'
      )}`
    );

    return this.http.post<IResponseUploadAttivazioneMassiva>(path, payload);
  }

  downloadPreAttivazionePrecompilato(
    payload: { action4: string },
    reteTerza: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/template/list/preactivate/${reteTerza}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, payload, options);
  }

  uploadPreAttivazioneFile(
    payload: FormData
  ): Observable<IResponseUploadPreAttivazione> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/list/preactivate?Authorization=${getCookie(
        'accessToken'
      )}`
    );

    return this.http.post<IResponseUploadPreAttivazione>(path, payload);
  }

  confermaPreAttivazioneFile(
    payload: IPayloadConfermaCaricamentoPreAttivazione
  ): Observable<IResponseConfermaCaricamentoPreAttivazione> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/list/preactivate'
    );

    return this.http.put<IResponseConfermaCaricamentoPreAttivazione>(
      path,
      payload
    );
  }

  uploadMassive(payload: FormData): Observable<IUploadFileResult> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/list/upload?Authorization=${getCookie(
        'accessToken'
      )}`
    );

    return this.http.post<IUploadFileResult>(path, payload);
  }

  uploadMassiveAssociation(
    payload: FormData,
    category: string
  ): Observable<IUploadFileResult> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/caricamentomassivo/${category}`
    );

    return this.http.post<IUploadFileResult>(path, payload);
  }

  uploadMassiveData(payload: any): Observable<GenericResponse> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/list/upload`
    );

    return this.http.put<GenericResponse>(path, payload);
  }

  uploadMassiveDataUtility(
    payload: any,
    utilityType: string
  ): Observable<GenericResponse> {
    let basepath = this.apiRoot + `/approvvigionamento/${utilityType}`;

    if (
      utilityType === 'catalogoMateriale' ||
      utilityType === 'ordine' ||
      utilityType === 'ordine/recovery'
    ) {
      basepath = `${basepath}/xls`;
    }

    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      basepath
    );

    return this.http.put<GenericResponse>(path, payload);
  }

  uploadMassiveDataAssociation(payload: any): Observable<GenericResponse> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/caricamentomassivo/associazionePPCluster`
    );

    return this.http.put<GenericResponse>(path, payload);
  }

  uploadFileMassiveUtility(
    payload: FormData,
    utilityType: string
  ): Observable<IUploadFileResult> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/${utilityType}`
    );

    return this.http.post<IUploadFileResult>(path, payload);
  }

  confermaAttivazioneMassivafile(
    payload: IPayloadConfermaCaricamentoAttivazioneMassiva
  ): Observable<IResponseConfermaCaricamentoAttivazioneMassiva> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/list/activate'
    );

    return this.http.put<IResponseConfermaCaricamentoAttivazioneMassiva>(
      path,
      payload
    );
  }

  retrieveUtilityLdv(payload: string): Observable<RetrieveUtilityLdv> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/movimentazione/list/${payload}`
    );

    return this.http.get<RetrieveUtilityLdv>(path);
  }

  retrieveGestioneUtenze(): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/operatore/list'
    );

    return this.http.get<any>(path);
  }

  retrieveCreazioneUtenza(
    payload: IPayloadCreazioneUtenza
  ): Observable<IResponseCreazioneUtenza> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/operatore'
    );

    return this.http.put<IResponseCreazioneUtenza>(path, payload);
  }

  retrieveCreazioneOrdine(payload: any): Observable<ResponseCreazioneOrdine> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/approvvigionamento/catalogoMaterialeListOrdinabili'
    );

    return this.http.post<ResponseCreazioneOrdine>(path, payload);
  }

  changeQuantityCreateOrder(payload: any): Observable<GenericResponse> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/approvvigionamento/ordine'
    );

    return this.http.put<GenericResponse>(path, payload);
  }

  retrieveListaReteTerze(): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/reteterza/listRTZ'
    );

    return this.http.get<any>(path);
  }

  retrieveCompensiRete(rete: string): Observable<IResponseCompensiRete> {
    let params = new HttpParams().set('rete', rete);

    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/compensi`
    );

    return this.http.get<IResponseCompensiRete>(path, { params });
  }

  downloadUtilityReportPuntoPoste(
    payload: IPayloadDownloadUtilityReportPuntoPoste
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/utility/report`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, payload, options);
  }

  retrieveCompensiRetePost(
    rete: string,
    file: FormData
  ): Observable<IResponseCompensiRetePost> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/compensi/${rete}`
    );

    return this.http.post<IResponseCompensiRetePost>(path, file);
  }

  retrieveConfigurazioneBoxless(): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/configurazionebxl'
    );

    return this.http.get<any>(path);
  }

  retrieveConfigurazioneBoxlessPost(
    payload: IConfigurazioneBoxless
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/configurazionebxl'
    );

    return this.http.post<any>(path, payload);
  }

  retrieveGestionePuntoPoste(
    idPuntoPoste?: string
  ): Observable<RetrieveGestionPuntoPoste> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/${idPuntoPoste}`
    );
    return this.http.get<RetrieveGestionPuntoPoste>(path);
  }

  retrieveCMPList(): Observable<ResponseCMP> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cmp/list`
    );
    return this.http.get<ResponseCMP>(path);
  }

  retrieveCP(payload: PayloadCP): Observable<ResponseCP> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp`
    );
    return this.http.post<ResponseCP>(path, payload);
  }

  retrieveAudit(idPuntoPoste: string): Observable<Blob> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/lavorazioni/${idPuntoPoste}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.get<Blob>(path, options);
  }

  retrieveReportGiacenzeList(
    idPuntoPoste: string
  ): Observable<IResponseReportGiacenzeList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/reportGiacenze/${idPuntoPoste}`
    );

    return this.http.get<IResponseReportGiacenzeList>(path);
  }

  retrieveReportGiacenzeXls(
    payload: IPayloadReportGiacenzeXls
  ): Observable<HttpResponse<Blob>> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/giacenze/xls`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.put<HttpResponse<Blob>>(path, payload, options);
  }

  retrieveReportGiacenzeLockerList(
    idPuntoPosteLocker: string
  ): Observable<IResponseReportGiacenzeLockerList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/retiLocker/reportGiacenzeLocker/${idPuntoPosteLocker}`
    );

    return this.http.get<IResponseReportGiacenzeLockerList>(path);
  }

  retrieveReportGiacenzeLockerXls(
    payload: IPayloadReportGiacenzeLockerXls
  ): Observable<HttpResponse<Blob>> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/retiLocker/reportGiacenzeLocker/xls`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.put<HttpResponse<Blob>>(path, payload, options);
  }

  retrieveFrazionarioList(
    uffPostale: string
  ): Observable<ResponseNearlistUffPostale> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/nearlist/${uffPostale}`
    );
    return this.http.get<ResponseNearlistUffPostale>(path);
  }

  retrieveFrazionarioXls(payload: PayloadNearlistXls): Observable<Blob> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/nearlist/xls`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.put<Blob>(path, payload, options);
  }

  downloadMig2(payload: IPayloadMig2Download): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/mig2/download'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.post<any>(path, payload, options);
  }

  cercaPerStrutturaRecapito(
    payload: PayloadCercaStrutturaRecapito
  ): Observable<ResponseCercaPerStrutturaRecapito> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/recapito/list'
    );

    return this.http.post<ResponseCercaPerStrutturaRecapito>(path, payload);
  }

  downloadListaRecapito(
    payload: Partial<ResponseCercaPerStrutturaRecapito>
  ): Observable<Blob> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/recapito/download'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.post<Blob>(path, payload, options);
  }

  downloadReportOrderHistory(payload: PayloadOrderHistory): Observable<Blob> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/approvvigionamento/storico/xls'
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
    };

    return this.http.post<Blob>(path, payload, options);
  }

  // Restituisce HttpResponse<ArrayBuffer> per poter leggere header e dati binari
  downloadCatalogoMateriale(
    sortKey?: string,
    sortDirection?: string
  ): Observable<HttpResponse<ArrayBuffer>> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/catalogoMateriale/xls`
    );

    let params: HttpParams | undefined;

    if (sortKey || sortDirection) {
      params = new HttpParams();
      if (sortKey) {
        params = params.set('sortKey', sortKey);
      }
      if (sortDirection) {
        params = params.set('sortOrder', sortDirection);
      }
    }

    const options: {
      headers?: HttpHeaders;
      observe: 'response';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'arraybuffer';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer',
      observe: 'response',
      params,
    };

    return this.http.get(path, options);
  }

  retrieveRecapito(idFraz: string): Observable<IResponseRecapito> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/recapito/${idFraz}`
    );
    return this.http.get<IResponseRecapito>(path);
  }

  ricercaComunicazioneBacheca(
    payload: IPayloadBoardList
  ): Observable<ResponseComunicationBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/comunicazione/bacheca/list'
    );
    return this.http.post<ResponseComunicationBoardList>(path, payload);
  }

  retrieveRecipients(): Observable<ResponseRetrieveRecipients> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/listaDestinatari`
    );
    return this.http.get<ResponseRetrieveRecipients>(path);
  }

  requestExport(idDestinatari: number): Observable<IResponseRichiediExport> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/listaDestinatari/report/${idDestinatari}`
    );
    return this.http.get<IResponseRichiediExport>(path);
  }

  retrieveReportBacheca(
    idBacheca: number
  ): Observable<ResponseReportBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca/report/${idBacheca}`
    );
    return this.http.get<ResponseReportBoardList>(path);
  }

  downloadExport(
    idDestinatari: number,
    typeComunication: string
  ): Observable<Blob> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/${typeComunication}/report/download/${idDestinatari}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.get<Blob>(path, options);
  }

  downloadExportBacheca(
    idBacheca: number,
    typeComunication: string
  ): Observable<Blob> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/${typeComunication}/report/download/${idBacheca}`
    );

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'json';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer' as 'json',
      observe: 'response' as 'body',
    };

    return this.http.get<Blob>(path, options);
  }

  retrieveListaCatalogoMateriale(): Observable<IResponseListaCatalogoMateriale> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/catalogoMateriale`
    );
    return this.http.get<IResponseListaCatalogoMateriale>(path);
  }

  retrieveRegoleOrdine(): Observable<IResponseRegoleOrdine> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,

      this.apiRoot + `/approvvigionamento/regoleOrdine`
    );
    return this.http.get<IResponseRegoleOrdine>(path);
  }

  retrieveStoricoOrdini(
    payload: PayloadOrderHistory
  ): Observable<ResponseOrderHistory> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/storico`
    );
    return this.http.post<ResponseOrderHistory>(path, payload);
  }

  retrieveStoricoOrdiniProfili(): Observable<IResponseStoricoOrdiniProfili> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/storico/profili`
    );
    return this.http.get<IResponseStoricoOrdiniProfili>(path);
  }

  retrieveStoricoOrdiniPartner(): Observable<IResponseStoricoOrdiniPartner> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/storico/partner`
    );
    return this.http.get<IResponseStoricoOrdiniPartner>(path);
  }

  saveListaCatalogoMateriale(
    payload: ISaveListaCatalogoMateriale
  ): Observable<GenericResponse> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/catalogoMateriale`
    );
    return this.http.put<GenericResponse>(path, payload);
  }

  saveConfigurazioneApprovvigionamento(
    payload: IPayloadConfigurazioneApprovvigionamento
  ): Observable<GenericResponse> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/configurazione`
    );
    return this.http.put<GenericResponse>(path, payload);
  }

  retrieveListaCluster(): Observable<IResponseCluster> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/cluster`
    );
    return this.http.get<IResponseCluster>(path);
  }

  //139172 – Tool per la rilevazione stato del PuntoPoste
  patchInattivitaCluster(
    id: string,
    patchData: any
  ): Observable<IResponseCluster> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/cluster/${id}`
    );
    return this.http.patch<IResponseCluster>(path, patchData);
  }

  retrieveListaConfigurazioneApprovvigionamento(): Observable<IResponseConfigurazioneApprovvigionamento> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/configurazione`
    );
    return this.http.get<IResponseConfigurazioneApprovvigionamento>(path);
  }

  verifyListRecipients(
    payload: IPayloadVerifyRecipientsList
  ): Observable<IResponseVerifyRecipientsList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/comunicazione/listaDestinatari/verifica'
    );

    return this.http.post<IResponseVerifyRecipientsList>(path, payload);
  }

  saveListRecipients(
    payload: IPayloadSaveRecipientsList
  ): Observable<SaveRecipientsList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/comunicazione/listaDestinatari'
    );

    return this.http.put<SaveRecipientsList>(path, payload);
  }

  editListRecipients(
    payload: IPayloadSaveRecipientsList
  ): Observable<SaveRecipientsList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/comunicazione/listaDestinatari'
    );

    return this.http.post<SaveRecipientsList>(path, payload);
  }

  retrieveHeaderDetail(
    idHeader: number
  ): Observable<IResponseRetrieveHeaderDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/header/${idHeader}`
    );
    return this.http.get<IResponseRetrieveHeaderDetail>(path);
  }

  saveHeaderDetail(
    payload: PayloadHeaderDetail
  ): Observable<IResponseRetrieveHeaderDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/header`
    );
    return this.http.put<IResponseRetrieveHeaderDetail>(path, payload);
  }

  retrieveMessageBoardList(
    idBacheca: number
  ): Observable<ResponseMessageBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca/${idBacheca}`
    );
    return this.http.get<ResponseMessageBoardList>(path);
  }

  saveEditHeaderDetail(
    payload: PayloadHeaderDetail
  ): Observable<IResponseRetrieveHeaderDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/header`
    );
    return this.http.post<IResponseRetrieveHeaderDetail>(path, payload);
  }

  retrieveListaFrazionario(
    payload: any
  ): Observable<IResponseOrdiniApprovvigionamento> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/approvvigionamento/ordine/cp`
    );
    return this.http.post<IResponseOrdiniApprovvigionamento>(path, payload);
  }

  retrieveRecipientsBoardList(): Observable<ResponseRecipientsBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/listaDestinatari/bacheca`
    );
    return this.http.get<ResponseRecipientsBoardList>(path);
  }

  retrieveIdRecipients(
    idDestinatari: number
  ): Observable<ResponseIdRecipients> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/listaDestinatari/${idDestinatari}`
    );
    return this.http.get<ResponseIdRecipients>(path);
  }

  retrieveHeaderList(): Observable<IResponseRetrieveHeaderDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/header/list`
    );
    return this.http.post<IResponseRetrieveHeaderDetail>(path, {});
  }

  retrieveSaveDetailMessageBoardList(
    payload: IPayloadSaveDetailMessageBoardList
  ): Observable<ResponseSaveDetailComunicationBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca`
    );
    return this.http.post<ResponseSaveDetailComunicationBoardList>(
      path,
      payload
    );
  }

  editHeaderState(
    payload: PayloadEditStateHeader
  ): Observable<IResponseRetrieveHeaderDetail> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/header/modificaStato`
    );
    return this.http.post<IResponseRetrieveHeaderDetail>(path, payload);
  }

  retrieveInvioDetailMessageBoardList(
    payload: IPayloadInvioDetailMessageBoardList
  ): Observable<ResponseInvioDetailComunicationBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca`
    );
    return this.http.post<ResponseInvioDetailComunicationBoardList>(
      path,
      payload
    );
  }

  retrieveInvioDetailMessageBoardListPut(
    payload: IPayloadInvioDetailMessageBoardList
  ): Observable<ResponseInvioDetailComunicationBoardList> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca`
    );
    return this.http.put<ResponseInvioDetailComunicationBoardList>(
      path,
      payload
    );
  }

  retrieveSaveDetailMessageBoardListPut(
    payload: IPayloadSaveDetailMessageBoardListPut
  ): Observable<ResponseSaveDetailComunicationBoardListPut> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca`
    );
    return this.http.put<ResponseSaveDetailComunicationBoardListPut>(
      path,
      payload
    );
  }

  retriveLogout(): Observable<{ esito: string }> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/listaAccessi/logout'
    );

    return this.http.put<{ esito: string }>(path, null);
  }

  deleteBachecaEl(idBacheca: number): Observable<IDeleteElNoticeboard> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/comunicazione/bacheca/${idBacheca}`
    );

    return this.http.delete<IDeleteElNoticeboard>(path);
  }

  retrievePinRecovery(
    paylaod: IPinRecoveryPayload
  ): Observable<IResponsePinRecovery> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/operatore/pin-recovery`
    );

    return this.http.post<IResponsePinRecovery>(path, paylaod);
  }

  retrieveStoricoIcon(
    payload: IPayloadStoricoIcon
  ): Observable<IResponseStoricoIcon> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operazioni/storicoCRMIcon/${payload.rete}`
    );
    return this.http.post<IResponseStoricoIcon>(path, payload);
  }

  //Attivazione forzata servizi
  attivazioneForzataServizio(
    idPuntoPoste: string,
    servizio: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/attivazione-forzata-servizio`
    );
    return this.http.post<any>(path, {
      id_univoco_attivazione: idPuntoPoste,
      nome_servizio: servizio,
    });
  }

  attivazioneForzataServiziCheck(
    idPuntoPoste: string
  ): Observable<IResponseListaAttivazioniPP> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/check-attivazioni-servizi/${idPuntoPoste}`
    );
    return this.http.get<IResponseListaAttivazioniPP>(path);
  }

  uploadForzaAttivazioneServiziMassivafile(
    payload: FormData
  ): Observable<IResponseUploadAttivazioneMassiva> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/verifica-attivazione-servizi-forzata-massiva?Authorization=${getCookie(
        'accessToken'
      )}`
    );
    return this.http.post<IResponseUploadAttivazioneMassiva>(path, payload);
  }

  // Caricamento massivo ferie
  uploadFileCaricamentoMassivoFerie(
    payload: FormData
  ): Observable<IResponseUploadFileFerieMassivo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/upload-file-caricamento-massivo-ferie-punti-poste?Authorization=${getCookie(
        'accessToken'
      )}`
    );
    return this.http.post<IResponseUploadFileFerieMassivo>(path, payload);
  }

  confermaAttivazioneForzataServiziMassivafile(
    payload: IPayloadConfermaCaricamentoAttivazioneMassiva
  ): Observable<IResponseConfermaCaricamentoAttivazioneMassiva> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/force-activate-services'
    );

    return this.http.put<IResponseConfermaCaricamentoAttivazioneMassiva>(
      path,
      payload
    );
  }

  confermaCaricamentoFileMassivoFerie(
    payload: IPayloadConfermaCaricamentoMassivoFileFerie
  ): Observable<IResponseConfermaCaricamentoFileFerieMassivo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/cp/elabora-file-caricamento-massivo-ferie-punti-poste'
    );

    return this.http.put<IResponseConfermaCaricamentoFileFerieMassivo>(
      path,
      payload
    );
  }

  // Caricamento massivo gestione utenze
  uploadFileCaricamentoMassivoGestioneUtenze(
    payload: FormData
  ): Observable<IResponseUploadFileGestioneUtenzeMassivo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/operatore/upload-file-caricamento-massivo-gestione-utenze?Authorization=${getCookie(
        'accessToken'
      )}`
    );
    return this.http.post<IResponseUploadFileGestioneUtenzeMassivo>(
      path,
      payload
    );
  }

  confermaCaricamentoFileMassivoGestioneUtenze(
    payload: IPayloadConfermaCaricamentoMassivoFileGestioneUtenze
  ): Observable<IResponseConfermaCaricamentoFileGestioneUtenzeMassivo> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/operatore/elabora-file-caricamento-massivo-gestione-utenze'
    );

    return this.http.put<IResponseConfermaCaricamentoFileGestioneUtenzeMassivo>(
      path,
      payload
    );
  }

  retrieveCampiUtente(username: string): Observable<IResponseGestioneUtenze> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/operatore/get-campi-utente-obbligatori/${username}`
    );

    return this.http.get<IResponseGestioneUtenze>(path)
  }

  updateCampiObbligatoriUtente(
    codiceFiscale: string,
    frazOrg: string,
    matricola: string
  ): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + '/operatore/update-campi-obbligatori');

      return this.http.post<any>(path, {
        codiceFiscale: codiceFiscale,
        frazOrg: frazOrg,
        matricola: matricola
      });
  }

  resetContattoOperatore(idCp: number, idOperatore: number, tipo: 'telefono' | 'mail'): Observable<any> {
    const path = pathGenerate(
      this.basepath,
      this.staticBasepath,
      this.isLocal,
      this.apiRoot + `/cp/operatore/reset-contatto/${idCp}/${idOperatore}/${tipo}`
    );
    return this.http.post<any>(path, {});
  }
}
